// extracted by mini-css-extract-plugin
export default {"friendsList":"styles_friendsList__7QJKo","label":"styles_label__Ogecj","buttons":"styles_buttons__ExP90","button":"styles_button__wDLMc","active":"styles_active__VIPM1"};